import React from "react";

const RecordsSummary = ({ summary }) => {
  return (
    <div className="pa3 bg-light-gray br3 mb3">
      <h3>Summary</h3>
      <p>Total Records: {summary.totalRecords}</p>
      <p>Total Weight: {summary.totalWeight}</p>
    </div>
  );
};

export default RecordsSummary;